import adminApi from "./adminApi";

// 🔹 Create user (ADMIN)
export const createUser = async (data) => {
  const res = await adminApi.post("/admin/users", data);
  return res.data;
};

// 🔹 Get all users (ADMIN)
export const fetchUsers = async () => {
  const res = await adminApi.get("/admin/users");
  return res.data;
};

// 🔹 Block / Unblock user (ADMIN)
export const toggleBlockUser = async (userId) => {
  const res = await adminApi.put(`/admin/users/${userId}/block`);
  return res.data;
};

// 🔹 Delete user (ADMIN)
export const deleteUser = async (userId) => {
  const res = await adminApi.delete(`/admin/users/${userId}`);
  return res.data;
};
